import React from 'react';
import { Link } from 'react-router-dom';
import Logo2 from '../../assets/Logo2.png';

const TermsOfService = () => {
  return (
    <div className="bg-slate-50 text-slate-800 min-h-screen font-sans selection:bg-blue-200">
      {/* Navigation */}
      <nav className="w-full bg-white/80 backdrop-blur-md border-b border-slate-200 fixed top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex justify-between items-center">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-11 h-11 bg-white rounded-xl flex items-center justify-center shadow-md shadow-blue-600/20 flex-shrink-0 overflow-hidden">
              <img src={Logo2} alt="ReviewMate logo" className="w-full h-full object-contain rounded-xl scale-150" />
            </div>
            <span className="font-bold text-lg md:text-xl text-slate-900 tracking-tight">ReviewMate</span>
          </Link>
          <div className="flex items-center gap-2 md:gap-4">
            <Link to="/login" className="text-xs md:text-sm font-medium text-slate-600 hover:text-blue-600 px-2 transition-colors">
              Log In
            </Link>
            <Link to="/register" className="bg-blue-600 text-white text-xs md:text-sm font-medium px-4 py-2 md:px-5 md:py-2.5 rounded-full hover:bg-blue-700 transition-all shadow-lg shadow-blue-600/20 hover:shadow-blue-600/40 whitespace-nowrap">
              Get Started
            </Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="pt-32 pb-20 px-6 max-w-4xl mx-auto">
        <h1 className="text-4xl font-extrabold text-slate-900 mb-8">Terms of Service</h1>
        <p className="text-slate-500 mb-8">Last Updated: {new Date().toLocaleDateString()}</p>
        
        <div className="space-y-8 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing and using ReviewMate ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our application.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">2. Description of Service</h2>
            <p>
              ReviewMate is an educational platform that utilizes Artificial Intelligence (AI) to summarize user-uploaded notes and documents into study materials ("Reviewers"). We also offer features such as Blockchain-secured asset minting to prove ownership of Reviewers, Study Groups for collaborative learning, and Board Prep modules.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">3. User Accounts and Content</h2>
            <p className="mb-4">
              You must register for an account to use most features of ReviewMate. You are responsible for maintaining the confidentiality of your account credentials.
            </p>
            <p className="mb-4">
              <strong>Your Content (No PDF Storage):</strong> You retain ownership of the original documents and notes you upload to ReviewMate. By uploading, you grant us a license to process this content specifically for generating Reviewers. We <strong>do not store or collect</strong> your original uploaded PDFs or raw files; they are processed ephemerally and discarded once your Reviewer is generated.
            </p>
            <p>
              <strong>AI Generated Content:</strong> ReviewMate uses NLP and AI to generate summaries. While we strive for accuracy, we do not guarantee the absolute correctness of AI-generated content. You are responsible for verifying the accuracy of your study materials.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">4. Blockchain and Asset Minting</h2>
            <p>
              ReviewMate allows users to mint their Reviewers as blockchain assets to secure ownership. By using this feature, you acknowledge that blockchain transactions are immutable and subject to network conditions. ReviewMate is not liable for lost assets due to user error or underlying network failures.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">5. Acceptable Use</h2>
            <p>
              You agree not to upload materials that infringe on the intellectual property rights of others, contain illegal content, or violate academic integrity policies of your educational institution. You also agree not to abuse the AI summarization features or attempt to disrupt the service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">6. Limitation of Liability</h2>
            <p>
              ReviewMate is provided "as is" for educational purposes. We are not liable for any direct, indirect, incidental, or consequential damages resulting from your use of the Service, including but not limited to academic performance or loss of data.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">7. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. We will notify users of significant changes via the application or email.
            </p>
          </section>
        </div>

        <div className="mt-16 text-center">
          <Link to="/" className="text-blue-600 hover:underline font-medium">
            &larr; Back to Home
          </Link>
        </div>
      </main>
    </div>
  );
};

export default TermsOfService;
